import React, { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { Navigation, Footer } from '../../components/landing';
import { getFaqCluster } from './faqClusterContent';

/**
 * Renders a single LOCKED FAQ-cluster page (Ticket 5). The visible <article>
 * copy is injected verbatim from faqClusterData.json via dangerouslySetInnerHTML
 * so it stays byte-for-byte identical to the approved package fragment.
 *
 * No JSON-LD is rendered here on purpose: scripts/prerender.js strips any
 * React-rendered ld+json and injects the locked FAQPage/Article schema itself.
 */
export const FaqClusterPage: React.FC = () => {
  const location = useLocation();
  const entry = getFaqCluster(location.pathname);

  useEffect(() => {
    if (!entry) return;
    document.title = entry.title;
    document.documentElement.lang = entry.htmlLang;
  }, [entry]);

  // Unknown path under /faq/* — send to the hub rather than 404.
  if (!entry) {
    const hub = location.pathname.startsWith('/fr/') ? '/fr/faq' : '/faq';
    return <Navigate to={hub} replace />;
  }

  return (
    <div className="min-h-screen bg-brand-bg font-body">
      <Navigation />
      <main className="pt-24 pb-8">
        <div
          className="faq-cluster-wrap max-w-[760px] mx-auto px-6"
          dangerouslySetInnerHTML={{ __html: entry.article }}
        />
      </main>
      <Footer />
    </div>
  );
};

export default FaqClusterPage;
